import React from 'react';
import { IconProps } from '../../../../assets/icons/types';

const ChevronLeftIcon = ({ className, color }: IconProps) => {
  return (
    <svg className={className} width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.98242 12.975L0.999227 7.00858L6.98242 1.02539"
        stroke={color ?? 'current-color'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ChevronLeftIcon;
